exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src4156872633/src/~/core-js/modules/_object-gops.js
// module id = ../../../../core-js/modules/_object-gops.js
// module chunks = 0